// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"670":"bb328559","840":"26ed371c"}[chunkId] + ".chunk.js";
};